import { useMutation, useQuery, useQueryClient } from "react-query";

import { mapKey } from "./keys";
import { callListMap, callUpdateMap } from "api/worker/map";
import { CleaningMapList } from "types/response/map";

type Params = {
  enabled?: boolean;
};

export const useListMapQuery = (input?: Params) => {
  return useQuery({
    queryKey: mapKey.list(),
    queryFn: callListMap,
    enabled: input?.enabled ?? true,
  });
};

export const useUpdateMapMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(callUpdateMap, {
    onSuccess: (_updated, variables) => {
      queryClient.setQueryData<CleaningMapList | undefined>(mapKey.list(), (prev) => {
        if (!prev) return undefined;
        return prev.map((m) =>
          m.mapId === variables.mapId
            ? {
                ...m,
                mapName: variables.mapName,
                description: variables.description,
                displaySetting: variables.displaySetting,
              }
            : m
        );
      });
    },
  });
};
